import React, { useState } from "react";
import styled from "styled-components";
import { Input, Button, COLOR_SYSTEM, Text } from "components/atoms";
import Dropdown, { DropdownMenuItem } from "components/molecules/Dropdown";
import { StepData } from "./index";

interface ExperimentStep1Props {
  data: StepData;
  onNext: (data: Partial<StepData>) => void;
  onCancel: () => void;
}

const ExperimentStep1: React.FC<ExperimentStep1Props> = ({ data, onNext, onCancel }) => {
  const [formData, setFormData] = useState({
    name: data.name || "",
    description: data.description || "",
  });

  const handleNext = () => {
    onNext({
      name: formData.name || undefined,
      description: formData.description || undefined,
    });
  };

  return (
    <Container>
      <StepTitle>기본 정보 입력</StepTitle>
      <StepDescription>
        실험의 기본 정보를 입력하세요. 실험명과 설명은 선택사항이며, 입력하지 않으면 자동으로
        생성됩니다.
      </StepDescription>

      <FormGroup>
        <Label>실험명 (선택)</Label>
        <Input
          placeholder="예: 약물 상담 Ground Truth 검증 실험"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
      </FormGroup>

      <FormGroup>
        <Label>실험 설명 (선택)</Label>
        <Input
          multiLine
          placeholder="실험의 목적과 내용을 간단히 설명하세요."
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          style={{ height: "200px" }}
        />
      </FormGroup>

      <ButtonGroup>
        <Button size="Medium" type="Text" variant="Ghost" color="Secondary" onClick={onCancel}>
          취소
        </Button>
        <Button size="Medium" type="Text" variant="Contained" color="Primary" onClick={handleNext}>
          다음
        </Button>
      </ButtonGroup>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StepTitle = styled(Text)`
  font-size: 18px;
  font-weight: 600;
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
`;

const StepDescription = styled(Text)`
  font-size: 14px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  line-height: 1.5;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export default ExperimentStep1;
